export var Priority;
(function (Priority) {
    Priority["Zero"] = "Zero";
    Priority["One"] = "One";
    Priority["Two"] = "Two";
    Priority["Three"] = "Three";
    Priority["Four"] = "Four";
    Priority["Five"] = "Five";
    Priority["Six"] = "Six";
    Priority["Seven"] = "Seven";
    Priority["Eight"] = "Eight";
    Priority["Nine"] = "Nine";
    Priority["Ten"] = "Ten";
})(Priority || (Priority = {}));
export var RuPriorityNamesSelectValues = [
    { label: '0', value: Priority.Zero },
    { label: '1', value: Priority.One },
    { label: '2', value: Priority.Two },
    { label: '3', value: Priority.Three },
    { label: '4', value: Priority.Four },
    { label: '5', value: Priority.Five },
    { label: '6', value: Priority.Six },
    { label: '7', value: Priority.Seven },
    { label: '8', value: Priority.Eight },
    { label: '9', value: Priority.Nine },
    { label: '10', value: Priority.Ten },
];
